import * as storymapStoreModule from '../../../store';
import { getCardType } from './use';
import { getCardById } from '../../../store/use';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType, CardColor } from '@/api/workspaceSettings/queries';
import { ChangeCardColor } from '../colors';
import { SetCardColor } from '../../../store/actions/colors/setCardColor';

export const CreateSetCardColorCommand = async (action: SetCardColor) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = getCardById(action.cardId);
    const cardType = getCardType(card);

    const activityId = await uuid.create();

    const boardActivity: any = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.CardColorChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,

        CardColor: action.color,
        CardColorOldValue: card.color,
        CardColorLabel:
            action.color === CardColor.TransparentAnnotation ? 'Transparent' : state.colors.find((x) => x.color === action.color).name,
        CardColorLabelOldValue:
            card.color === CardColor.TransparentAnnotation ? 'Transparent' : state.colors.find((x) => x.color === card.color)?.name,
    };

    const cmd = new ChangeCardColor(card.id, state.id, cardType, action.color);

    cmd.BoardActivity = boardActivity;

    return cmd;
};
